import { Predicate } from 'effect';
import type { CaseAbility } from '@/abilities/createCaseAbility';
import type { DestinationAction, DestinationTree } from '@/abilities/destination';
import type { CompanySettingsDestination } from '@/abilities/companySettings/vocabulary';

/** A destination of the company Bank Feed page: the page itself and its tabs. */
export type CompanyBankFeedDestinationKey = 'root' | 'transactions' | 'creditCards';

/**
 * Each container's children, in landing order — the order its address looks for an open child. The order shown on
 * screen is the page's own list; reordering that one never moves where a user lands.
 */
export const companyBankFeedDestinationTree: DestinationTree<CompanyBankFeedDestinationKey> = {
  root: ['transactions', 'creditCards'],
};

export const COMPANY_BANK_FEED_DESTINATION = 'CompanyBankFeedDestination';

export type CompanyBankFeedDestination = {
  readonly kind: typeof COMPANY_BANK_FEED_DESTINATION;
  readonly destination: CompanyBankFeedDestinationKey;
};

export type CompanyBankFeedAction = DestinationAction;

// The page's shortcuts into settings are answered by the settings Bank Feed rules, held here beside the case's own.
export type CompanyBankFeedAbility = CaseAbility<
  CompanyBankFeedAction,
  CompanyBankFeedDestination | CompanySettingsDestination
>;

export const toCompanyBankFeedDestination = (
  destination: CompanyBankFeedDestinationKey,
): CompanyBankFeedDestination => ({
  kind: COMPANY_BANK_FEED_DESTINATION,
  destination,
});

export const isCompanyBankFeedDestination = (value: unknown): value is CompanyBankFeedDestination =>
  Predicate.hasProperty(value, 'kind') && value.kind === COMPANY_BANK_FEED_DESTINATION;
